import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Portal from "@/pages/Portal";
import DealBook from "@/pages/DealBook";
import PayNow from "@/pages/PayNow";
import CommercialProperty from "@/pages/CommercialProperty";
import LuxuryPipeline from "@/pages/LuxuryPipeline";
import EmployeeLogin from "@/pages/EmployeeLogin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/home" element={<Landing />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/land-acquisition" element={<DealBook />} />
      <Route path="/pay/:token" element={<PayNow />} />
      <Route path="/commercialproperties" element={<CommercialProperty />} />
      <Route path="/commercial-property" element={<Navigate to="/commercialproperties" replace />} />
      <Route path="/luxury-apartments" element={<LuxuryPipeline />} />
      <Route path="/wealth-management" element={<LuxuryPipeline interest="mutual-funds" />} />
      <Route path="/employee-login" element={<EmployeeLogin />} />
      <Route path="/pipeline" element={<Navigate to="/land-acquisition" replace />} />
      <Route path="/admin" element={<Navigate to="/land-acquisition" replace />} />
    </Routes>
  );
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#0B0C10] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{
        style: { background: "#14161C", border: "1px solid rgba(200,169,126,0.3)", color: "#F8F9FA" },
      }} />
    </div>
  );
}

export default App;
